import { useNavigate } from 'react-router-dom';

import { Button } from '@backstage/ui';

interface GoToResourceButtonProps {
  resourceName: string;
  label: string;
}

export const GoToResourceButton = ({
  resourceName,
  label,
}: GoToResourceButtonProps) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="primary"
      size="small"
      onPress={() => navigate(`/${resourceName}`)}
    >
      {`Go to ${label}`}
    </Button>
  );
};
